import { Space } from 'antd';

import { Button, Form, FormItemDatePicker } from '../../../components/index';
import { createDateString, disabledDateAfterToday } from '../../../utils/utils';
import { BaseActionModalProps } from './staymentActions';

type PilotExpectedOnBoardUndockingProps = BaseActionModalProps & {
  onPilotExpectedOnBoard: () => void;
};

export function PilotExpectedOnBoardUndocking(
  props: PilotExpectedOnBoardUndockingProps
) {
  const {
    setIsVisible,
    currentDocking,
    updateDocking,
    isLoadingUpdateDocking,
    onPilotExpectedOnBoard,
  } = props;
  const [form] = Form.useForm();

  function handleForm(values: any) {
    if (updateDocking) {
      updateDocking(
        {
          ...values,
          pilot_expected_on_board_undocking: createDateString(
            values.pilot_expected_on_board_undocking
          ),
          id: currentDocking?.id,
        },
        onPilotExpectedOnBoard
      );
    }
  }
  return (
    <Form form={form} layout="vertical" onFinish={handleForm}>
      <b>
        Para liberar a desatracação é necessário informar a previsão de prático
        a bordo
        <br />
        <br />
      </b>
      <FormItemDatePicker
        name="pilot_expected_on_board_undocking"
        disabledDate={disabledDateAfterToday}
        label="Previsão de prático a bordo na desatracação:"
        colSpan={12}
        tooltip=""
        rules={[
          {
            required: true,
            message:
              'Por favor, preencha a previsão de prático a bordo na desatracação',
          },
        ]}
      />
      <Space
        size={12}
        style={{
          justifyContent: 'flex-end',
          display: 'flex',
          marginTop: '20px',
        }}
      >
        <Button type="text" onClick={() => setIsVisible(false)}>
          Cancelar
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          loading={isLoadingUpdateDocking}
        >
          Continuar
        </Button>
      </Space>
    </Form>
  );
}
